import type { FC } from 'react';
import type { AppIconsIcon } from '../../../public/icon-font/app-icons';
import { ScIconComponent } from './styled';

interface IconComponentProps {
  name: AppIconsIcon;
  size?: string;
  className?: string;
}

export const IconComponent: FC<IconComponentProps> = ({
  name,
  size,
  className,
}) => (
  <ScIconComponent $size={size} className={`icon-${name} ${className || ''}`} />
);
